import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { rawRequest } from "@/api/client";
import { contractKeys } from "@/hooks/api/useContracts";

// TODO: replace with generated types after openapi regen exposes
// /api/v1/contracts/{contract_id}/settlements (GET + POST).
export interface SettlementResponse {
  id: string;
  period_start: string;
  period_end: string;
  total_advanced: number;
  total_actual: number;
  difference: number;
  direction: "charge" | "refund" | "none";
  invoice_id: string | null;
  note: string | null;
}

// TODO: replace with generated type after openapi regen
export interface SettlementCreateBody {
  period_start: string;
  period_end: string;
  total_actual: number;
  total_advanced?: number;
  note?: string;
}

const key = (id: string) => ["contracts", id, "settlements"] as const;

export function useSettlements(contractId: string | undefined) {
  return useQuery({
    queryKey: key(contractId ?? ""),
    enabled: Boolean(contractId),
    queryFn: async () =>
      rawRequest<SettlementResponse[]>(
        "GET",
        `/api/v1/contracts/${contractId}/settlements`,
      ),
  });
}

export function useCreateSettlement(contractId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: SettlementCreateBody) =>
      rawRequest<SettlementResponse>(
        "POST",
        `/api/v1/contracts/${contractId}/settlements`,
        body,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: key(contractId) });
      qc.invalidateQueries({ queryKey: ["invoices"] });
      qc.invalidateQueries({ queryKey: ["contracts", contractId, "billing"] });
      qc.invalidateQueries({ queryKey: contractKeys.detail(contractId) });
    },
  });
}
